import { render } from "./ByosReview.vue?vue&type=template&id=5357b487"
import script from "./ByosReview.vue?vue&type=script&setup=true&lang=js"
export * from "./ByosReview.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/byos/ByosReview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5357b487"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5357b487', __exports__)) {
    api.reload('5357b487', __exports__)
  }
  
  module.hot.accept("./ByosReview.vue?vue&type=template&id=5357b487", () => {
    api.rerender('5357b487', render)
  })

}


export default __exports__